<template>
  <div class="doll-root" :class="{ mini: mini }">
    <fill-button
      v-if="showBubbles"
      v-show="!showClenchHint"
      class="left-btn relative"
      is-left
      :action="bubbleActions[0]"
      :hit="isLeftHit"
      :mini="mini"
      :breathing="leftBreathing"
      @click="$emit('left-click')"
      @active="$emit('left-active')"
    />
    <fill-button
      v-if="showBubbles"
      v-show="!showClenchHint"
      class="right-btn relative"
      :action="bubbleActions[1]"
      :hit="isRightHit"
      :mini="mini"
      :breathing="rightBreathing"
      @click="$emit('right-click')"
      @active="$emit('right-active')"
    />
    <img
      class="arm left-arm absolute"
      :style="leftArmStyles"
      src="../../assets/stamp/left-arm.svg"
    />
    <img
      class="arm right-arm absolute"
      :style="rightArmStyles"
      src="../../assets/stamp/right-arm.svg"
    />
    <template v-if="showClenchHint">
      <img class="absolute clench clench-left" src="../../assets/stamp/left-clench.png" />
      <img class="absolute clench clench-right" src="../../assets/stamp/right-clench.png" />
    </template>
    <scan-progress v-if="showProgress" :progress="progress" />
  </div>
</template>

<script>
import incein from '@/mixins/incein';
import doll from '@/mixins/doll';
import audioPlayer from '@/mixins/audio-player';

import FillButton from './FillButton.vue';
import ScanProgress from './ScanProgress.vue';

export default {
  name: 'Doll',
  components: {
    FillButton,
    ScanProgress,
  },
  mixins: [doll, audioPlayer, incein],
  watch: {
    showClenchHint: {
      handler(nv, ov) {
        if (nv && !ov) {
          this.playAudio('v13_9');
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.doll-root {
  width: 50%;
  max-width: 193px;
  min-width: 193px;
  height: 100%;
  max-height: 505px;
  min-height: 505px;
  background: url('../../assets/stamp/doll-base.svg') center no-repeat;
  background-size: contain;
  @apply relative flex justify-center items-center my-auto mx-auto;
  &.mini {
    transform: scale(0.42);
    margin-top: -19%;
  }
}
.arm {
  width: 50%;
  top: 22.5%;
}
.left-arm {
  left: -17%;
  transform-origin: 60% 5%;
}
.right-arm {
  right: -18.5%;
  transform-origin: 40% 5%;
}
.clench {
  top: 40%;
  &.clench-left {
    right: 110%;
  }
  &.clench-right {
    left: 110%;
  }
}
</style>
